const useModifyProductReview = (data) => {
  const calculateProductScore = (score) => (score ? score / 2 : 0);

  const calculateTotalReviewsNum = () => {
    const proScoreDist = data?.pro_score_dist_all || [];
    const userScoreDist = data?.user_score_dist_all || [];
    return proScoreDist
      .concat(userScoreDist)
      .reduce((acc, curr) => acc + curr, 0);
  };

  const calculateTotalScoreForEachRate = () => {
    const totalScoreForEachRate = {};
    for (let i = 1; i <= 5; i++) {
      const proScore = data?.pro_score_dist_all?.[i - 1] || 0;
      const userScore = data?.user_score_dist_all?.[i - 1] || 0;
      totalScoreForEachRate[i] = proScore + userScore;
    }
    return totalScoreForEachRate;
  };

  const calculateTotalPercentageForEachRate = () => {
    const totalPercentageForEachRate = {};
    const totalReviews = calculateTotalReviewsNum();

    for (let i = 1; i <= 5; i++) {
      const proScore = data?.pro_score_dist_all?.[i - 1] || 0;
      const userScore = data?.user_score_dist_all?.[i - 1] || 0;
      totalPercentageForEachRate[i] = `${(
        ((proScore + userScore) / totalReviews || 0) * 100
      ).toFixed(2)}%`;
    }

    return totalPercentageForEachRate;
  };

  const productScore = calculateProductScore(data?.score);
  const totalReviewsNum = calculateTotalReviewsNum();
  const totalScoreForEachRate = calculateTotalScoreForEachRate();
  const totalPercentageForEachRate = calculateTotalPercentageForEachRate();

  return {
    productScore,
    totalReviewsNum,
    totalScoreForEachRate,
    totalPercentageForEachRate,
  };
};

export default useModifyProductReview;
